import { render, staticRenderFns } from "./TouristGroup.vue?vue&type=template&id=3fbf54ce&scoped=true&"
import script from "./TouristGroup.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TouristGroup.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TouristGroup.vue?vue&type=style&index=0&id=3fbf54ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf54ce",
  null
  
)

export default component.exports